// crypto.randomUUID needs a secure context and Chrome 92 / Safari 15.4 / Firefox 95.
// Without it the public apply page crashed on every render (error patrol 2026-11-04).
// getRandomValues works everywhere, so build the same v4 UUID from it; the API parses
// these ids as UUIDs, so the fallback must keep the version and variant bits.
export function randomUUID(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID()
  const b = crypto.getRandomValues(new Uint8Array(16))
  b[6] = (b[6] & 0x0f) | 0x40
  b[8] = (b[8] & 0x3f) | 0x80
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("")
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}
